
<template>
<div class="order-goods-info">
    <div class="order-goods-img-box">
        <img class="order-goods-img" :src="$config.fileUrl + goodsData.pictureUrl" />
    </div>
    <div class="order-goods-flex">{{goodsData.goodsName || goodsData.productName}}</div>
    <div class="order-info">
        <div class="order-info-text black">{{goodsData.discountPrice}}积分</div>
        <template  v-if="type == 'orderList'">
            <div class="order-info-text quantity">×{{goodsData.quantity}}</div>
            <div class="order-info-text">合计：<span class="total black">{{goodsData.paymentPoints}}积分</span></div>
        </template>
        <template v-else>
            <div class="order-info-text quantity">×{{goodsData.num}}</div>
            <div class="order-info-text" v-if="isTotal">合计：<span class="total black">{{goodsData.totalPrice}}积分</span></div>
        </template>
    </div>
</div>
</template>

<script>
export default {
  name: 'pi-order-item-data',
  data () {
    return {
      
    };
  },
  methods: {
    
  },
  mounted () {

  },
  props:{
    goodsData: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    isTotal: {
      type: Boolean,
      default: true
    }
    ,
    type: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less">
.order-goods-info{
  display: flex;
  padding: 0.20rem;
  border-top: 0.01rem solid #F5F4F9;
  font-size: 0.28rem;
  line-height: 0.40rem;
  color: #666666;

  .order-goods-img-box{
    width: 1.60rem;
  }
  .quantity{
    font-size: 0.24rem;
    line-height: 0.32rem;
    
  }
  .order-goods-img-box .order-goods-img{
    height: 1.41rem;
    width: 100%;
  }
  .order-goods-flex{
    flex: 1;
    color: #000;
  }
  .order-info{
    text-align: right;
  }
  .order-info-text{
    margin-top: 0.10rem;
  }
  .order-info-text:first-child{
    margin-top: 0;
  }
  .order-goods-info .black{
    color: #000000;
  }
}
</style>
